/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const FileEditLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m21 6.76-2 2V4h-9v5H5v11h14v-2.76l2-2v5.77a1 1 0 0 1-1 .99H4a1 1 0 0 1-1-1V8l6-6h11a1 1 0 0 1 1 1zm.78 2.05 1.41 1.41L15.41 18H14v-1.41z" />
  </Icon>
);
